/**
 * @param depth The depth of the terrace in meter
 */
export const terrace = {
  depth: 3,
}
